var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-tool-tip',{staticClass:"aiCreditsToolTip",attrs:{"label":_vm.$t('generic.aiCreditsTooltip'),"interactive":true,"position":_vm.position}},[_vm._t("default",function(){return [_c('w-icon',{staticClass:"aiCreditsIcon",attrs:{"icon":"star-four-points-circle-outline","size":"small","color":"warning"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }